<template>
    <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in listInfo" :style="{ backgroundImage: 'url(' + item.imageUrl + ')' }" :class="{pointer: item.targetType != -1  }" @click="choiceMethod(item.targetType, item.targetUrl, item.isTargetAutoPlay)"></div>
        </div>
        <div v-if="listInfo.length > 1" class="pagination"></div>
        <div v-if="hasBtn" class="swiper-button-prev"></div>
        <div v-if="hasBtn" class="swiper-button-next"></div>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    // import 'swiper/dist/css/swiper.min.css';
    import 'swiper/dist/idangerous.swiper.css';
    import Bus from '../../api/bus.js';
    import apiUrl from '../../api/apiUrl.js'


    export default {
        props: ['listInfo', 'hasBtn'],
        mounted() {
          // 采用高版本swiper在ie上不兼容
          // var swiper = new Swiper('.swiper-container', {
          //     speed: 1000,
          //     delay: 3000,
          //     autoplay: {
          //       stopOnLastSlide: false,
          //       disableOnInteraction: true
          //     },
          //     pagination: {
          //       el: '.swiper-pagination',
          //       type: 'custom',
          //       clickable: true,
          //       renderCustom: function (swiper, current, total) {
          //         const activeColor = '#FF789E'
          //         const normalColor = '#E0E0E0'
          //         let color = ''
          //         let height = ''
          //         let paginationStyle = ''
          //         let html = ''
          //         for (let i = 1; i <= total; i++) {
          //             if (i === current) {
          //             color = activeColor
          //             height = '4px'
          //             } else {
          //             color = normalColor
          //             height = '2px'
          //             }
          //             paginationStyle = `background:${color};width:30px;height:${height};border-radius:4px;opacity:1;margin-right:10px;`
          //             html += `<span class="swiper-pagination-bullet" style=${paginationStyle}></span>`
          //         }
          //         return html
          //       }
          //     },
          //     navigation: {
          //         nextEl: '.swiper-button-next',
          //         prevEl: '.swiper-button-prev',
          //         hideOnClick: true,
          //     },
          //     onTouchEnd: function() {
          //       swiper.startAutoplay()
          //     }
          // });
          var mySwiper = new Swiper('.swiper-container',{
            autoplay : 3000,//可选选项，自动滑动
            speed: 1500,
            preventLinks: false,
            pagination : '.pagination',
            paginationClickable :true,
            // loop : true,//可选选项，开启循环
          })
        },
        components: {
        },
        created() {
          const length = this.listInfo.length;
          for (let i = 0; i < this.listInfo.length; i++) {
            if(this.listInfo[i].targetType == 2) {
              if(this.listInfo[i].isTargetAutoPlay && apiUrl.globalData.isAutoPlay) {
                console.log('自动播放视频');
                this.isShowVideo(this.listInfo[i].targetUrl, this.listInfo[i].isTargetAutoPlay);
              }
            }
          }
        },
  
        methods: {
          choiceMethod: function (type, targetUrl, isAutoplay) {
            if (type === 2) {
              this.isShowVideo(targetUrl, isAutoplay);
            } else if (type === 1 || type === 0) {
              this.isGoTarget(targetUrl);
            } else {

            }
          },
          isShowVideo: function (targetUrl, isAutoplay) {
            const options = {targetUrl: targetUrl, isAutoplay: isAutoplay};
            Bus.$emit('isShowVideo', options);
          },
          isGoTarget: function (targetUrl) {
            if (targetUrl) {
              if (targetUrl.indexOf('http://') == -1  && targetUrl.indexOf('https://') == -1) {
                targetUrl = 'http://' + targetUrl;
              } 
              window.location.href = targetUrl;
            } else {
              console.log('错误Url:' + targetUrl);
            }
          }
        }
    }
</script>

<style lang="scss" scoped>
    .swiper-container {
        width: 100%;
        height: 100%;
        position: relative;
        .swiper-wrapper {
            width: 100%;
            height: 100%;
        }
        .swiper-slide {
            background-position: center;
            background-size: cover;
            width: 100%;
            height: 100%;
            img {
              width: 100%;
              height: 100%;
            }
        }
        .pointer{
          cursor: pointer;
        }
    .low-bottom {
      position: absolute;
      bottom: 10px;
    }
    .pagination {
      position: absolute;
      z-index: 20;
      bottom: 10px;
      width: 100%;
      text-align: center;
      // .swiper-pagination-switch {
      //   display: inline-block;
      //   width: 8px;
      //   height: 8px;
      //   border-radius: 8px;
      //   background: #555;
      //   margin: 0 5px;
      //   opacity: 0.8;
      //   border: 1px solid #fff;
      //   cursor: pointer;
      // }
      // .swiper-active-switch {
      //   background: #fff;
      // }
  }

    .swiper-button-prev{margin-left: 120px;background:url("../../assets/images/arrow_left.png") ; background-size: 100% 100%; background-repeat: no-repeat;width: 80px; height: 80px;}
    .swiper-button-next{margin-right: 120px;background:url("../../assets/images/arrow_right.png"); background-size: 100% 100%; background-repeat: no-repeat;width: 80px; height: 80px;}
    }
</style>


// WEBPACK FOOTER //
// src/components/swiper/swiper.vue